<div class="wizard-step">
  <ng-template #sectionsContainer></ng-template>

  <div class="wizard-step__bottom"></div>
</div>
